import { MAX_VALUES } from "../../constants/NoteValues";

export function MobileTabContent({
  noteStates,
  noteTotal,
  isAdmin,
  handleNoteChange,
}) {
  const NoteInput = ({ note, index }) => (
    <input
      type="number"
      className="w-[25%] min-h-12 text-center border rounded-md"
      value={note?.value || ""}
      onChange={(e) => handleNoteChange(note.module, e.target.value, index)}
      disabled={noteStates[index].exist && !isAdmin}
      min={0}
    />
  );

  return (
    <div className="flex flex-col gap-4">
      {noteStates.map((n, i) => (
        <div
          key={i}
          className="border p-2 bg-white rounded-md shadow-md flex justify-between items-center"
        >
          <span className="font-bold">
            {n.moduleName} / {MAX_VALUES[n.module]}
          </span>
          <NoteInput note={n} index={i} />
        </div>
      ))}

      <div className="border p-2 bg-white rounded-md shadow-md flex justify-between items-center">
        <span className="font-bold">Total</span>
        <input
          type="number"
          className="w-[25%] min-h-12 text-center border rounded-md"
          value={noteTotal}
          readOnly
        />
      </div>
    </div>
  );
}
